import { Routes, Route, Navigate } from 'react-router-dom'
import { Shell } from './components/Shell'
import { LandingPage } from './pages/LandingPage'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ProjectPage } from './pages/ProjectPage'
import { WorkspacePage } from './pages/WorkspacePage'
import { ActorsPage } from './pages/ActorsPage'
import { TemplatesPage } from './pages/TemplatesPage'
import { PricingPage } from './pages/PricingPage'

export function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/project/:id" element={<ProjectPage />} />
        <Route path="/project/:id/workspace" element={<WorkspacePage />} />
        <Route path="/actors" element={<ActorsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  )
}
